import { CampusCardAccountType } from './campus_card_account_type.js';

export function name(accountType: CampusCardAccountType): string {
  switch (accountType) {
    case CampusCardAccountType.StoredValue:
      return 'Stored Value';
    case CampusCardAccountType.MealPlan:
      return 'Meal Plan';
    case CampusCardAccountType.CashEquivalency:
      return 'Cash Equivalency';
  }
}

/** Atrium vocabulary for the same account buckets. */
export function atriumName(accountType: CampusCardAccountType): string {
  switch (accountType) {
    case CampusCardAccountType.StoredValue:
      return 'Declining Balance';
    case CampusCardAccountType.MealPlan:
      return 'Meal Exchange';
    case CampusCardAccountType.CashEquivalency:
      return 'Cash Equivalency';
  }
}
